import type { QueryClient } from "@tanstack/react-query";
import {
  getAssistantProcessesQueryKey,
  getDocumentQueryKey,
  getDocumentsQueryKey,
} from "src/config/request-keys";

export const invalidateAnswerQueries = async ({
  queryClient,
  orgId,
  deviceIds,
  documentIds,
}: {
  queryClient: QueryClient;
  orgId: string;
  deviceIds: string[];
  documentIds: string[];
}) => {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: getDocumentsQueryKey(""),
      refetchType: "all",
    }),
    ...deviceIds.map((deviceId) =>
      queryClient.invalidateQueries({
        queryKey: getDocumentsQueryKey(deviceId),
        refetchType: "all",
      })
    ),
    ...documentIds.map((documentId) =>
      queryClient.invalidateQueries({
        queryKey: getDocumentQueryKey(documentId),
        refetchType: "all",
      })
    ),
    ...deviceIds.map((deviceId) =>
      queryClient.invalidateQueries({
        queryKey: getAssistantProcessesQueryKey(orgId, deviceId),
        refetchType: "all",
      })
    ),
  ]);
};
